import React from 'react';
import { Box, Typography, Stack, Chip, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const proficiencyColors = {
    Native:       'success',
    Fluent:       'primary',
    Advanced:     'info',
    Intermediate: 'warning',
    Basic:        'default',
};

const LanguageList = ({ languages, onEdit, onDelete }) => {
    if (!languages || languages.length === 0) {
        return (
            <Typography variant="body2" color="text.secondary" sx={{ py: 1 }}>
                No languages added yet
            </Typography>
        );
    }

    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
            {languages.map(lang => (
                <Stack key={lang.id} direction="row" spacing={0.75} alignItems="center">
                    <Chip
                        label={lang.title}
                        size="small"
                        variant="outlined"
                        sx={{ fontWeight: 500 }}
                    />
                    {lang.proficiency && (
                        <Typography variant="caption" color="text.secondary">
                            {lang.proficiency}
                        </Typography>
                    )}
                    {(onEdit || onDelete) && (
                        <Stack direction="row" spacing={0}>
                            {onEdit && (
                                <IconButton size="small" onClick={() => onEdit(lang)} sx={{ p: 0.25 }}>
                                    <EditIcon sx={{ fontSize: 13 }} />
                                </IconButton>
                            )}
                            {onDelete && (
                                <IconButton size="small" color="error" onClick={() => onDelete(lang)} sx={{ p: 0.25 }}>
                                    <DeleteIcon sx={{ fontSize: 13 }} />
                                </IconButton>
                            )}
                        </Stack>
                    )}
                </Stack>
            ))}
        </Box>
    );
};

export default LanguageList;
